module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAMAAAC3SZ14AAAAOVBMVEUAAACdpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLadpLY2KtWOAAAAEnRSTlMA8g3rrEUoxy7dmj8GfXnYv6JbG50HAAAAg0lEQVQY03WQWRLDIAxDbUPYQjbd/7Cl1VDoEn0xb4wsWbqA/rpFC9HyBuEEEc5AsiockYOurxmFNyLz0OdchB/2HrFZwtnYYw6LFGwyaUeRjDSjhCxAnVEFRD+RNXT8fry+7a8/IRiVYtRRqImFeu09VUtbr93mIkDFME5YMvQoPOEDTlwGUgcZshsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_logout_hover.png
// module id = 2PR/
// module chunks = 9